// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3oNTH","errorLogs":"styles_errorLogs__3dOhV"};